// The sync bar's state, pure (plan "Offline" UI): nothing when online and
// synced; amber "Offline — N waiting"; sky "Syncing N…"; a 4-second success
// bar; a persistent, non-dismissable danger bar while anything needs
// attention (partial failure).

export const SUCCESS_BAR_MS = 4000;

export type SyncBarTone = 'danger' | 'offline' | 'syncing' | 'success';

export interface SyncBarState {
  tone: SyncBarTone;
  text: string;
}

export function syncBarState(input: {
  online: boolean;
  pending: number;
  attention: number;
  drainedAt: number | null;
  now: number;
}): SyncBarState | null {
  const { online, pending, attention, drainedAt, now } = input;
  if (attention > 0) {
    const waiting = pending > 0 ? ` · ${pending} still waiting` : '';
    return {
      tone: 'danger',
      text: `${attention} ${attention === 1 ? 'check-in or payment needs' : 'check-ins or payments need'} attention${waiting}`,
    };
  }
  if (!online) return { tone: 'offline', text: `Offline — ${pending} waiting` };
  if (pending > 0) return { tone: 'syncing', text: `Syncing ${pending}…` };
  if (drainedAt !== null && now - drainedAt < SUCCESS_BAR_MS) return { tone: 'success', text: 'All changes synced' };
  return null;
}
